module.exports = __webpack_public_path__ + "img/ctrl-c-stub-down-+.647e7cfc.svg";